import { getRequest } from '../../../utils/functions/httpRequest'
import { URL } from '../../../config'

const reportsURL = URL.reports
const seasonURL = URL.season

export const getHistory = function(){
   const endPoint = `${reportsURL}/history`
   return getRequest(endPoint)
}

export const getReports = function(season, reporttype){
   const endPoint = `${reportsURL}/${season}/${reporttype}`
   return getRequest(endPoint)
 }

 export const getSeasonDates = function(){
   const endPoint = `${seasonURL}/active`
   return getRequest(endPoint)
 }


// WEBPACK FOOTER //
// ./src/containers/reports/api/index.js